import { useCallback, useEffect, useState } from 'react'

import { useWalletConnectGuard } from './wallet'
import useAuth from './auth'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'

export const useFirebaseAuthGuard = (callback: () => void): (() => void) => {
  const { loading, token, signIn, isConnected } = useAuth()
  const [isRequested, setIsRequested] = useState(false)
  const { visible } = useWalletModal()

  const guardedAction = useCallback(async () => {
    if (loading || !token) {
      setIsRequested(true)

      if (isConnected && !visible) {
        signIn()
      }
    } else {
      callback()
    }
  }, [loading, token, isConnected, signIn, callback, visible])

  useEffect(() => {
    if (!token) {
      return
    }

    if (isRequested) {
      setIsRequested(false)
      callback()
    }
  }, [callback, isRequested, token])

  return useWalletConnectGuard(guardedAction)
}
